import ffDinRegular from './ffdin-regular'
import ffDinBold from './ffdin-bold'
import courgette from './Courgette-Regular-normal'
import fuggles from './Fuggles-Regular-normal'
import satisfy from './Satisfy-Regular-normal'
import noseven from './No-Seven-Regular-normal'

const fontList = [
    {
        name: 'Courgette',
        slug:'Courgette-Regular'
    },
    {
        name: 'Satisfy',
        slug:'Satisfy-Regular'
    },
    {
        name: 'Helvetica',
        slug:'helvetica'
    },
    {
        name: 'FFDin',
        slug:'ffdin',
        styles:[
            {
                name: 'Normal',
                slug: 'normal',
                icon: 'title'
            },
            {
                name: 'Negrito',
                slug: 'bold',
                icon: 'format_bold'
            }
        ]
    },
    {
        name: 'NoSeven',
        slug:'No-Seven-Regular'
    }
]

export { 
    fontList
}